import React, { useEffect } from 'react';
import { Link, Route, Switch, useHistory } from 'react-router-dom';
import { Notifier } from '@airbrake/browser';
import Layout from '@bringg/react-components/dist/components/layout/layout';
import LayoutContent from '@bringg/react-components/dist/components/layout-content/layout-content';
import LayoutHeader from '@bringg/react-components/dist/components/layout-header/layout-header';
import { Button, Input, Spin } from 'antd';

import { ErrorBoundary } from 'Components';
import { DemoExecution, DemoList, DemoSettings, Login, Logout } from 'Features';
import { useAirbrake } from 'Hooks';
import { useAuth } from 'Providers';

import './App.scss';

function App() {
  const { isLoggedIn, isLoading } = useAuth();
  const history = useHistory();
  const airbrake = useAirbrake();

  useEffect(() => {
    if (!history || isLoading) {
      return;
    }
  }, [isLoggedIn, history, isLoading]);

  if (isLoading) {
    return (
      <div className="app-loader">
        <Spin />
      </div>
    );
  }

  return (
    <ErrorBoundary airbrake={airbrake as Notifier}>
      <Layout className="app-main-layout">
        {isLoggedIn ? (
          <>
            <LayoutHeader>
              <Link className="main-link" to="/">
                <svg className="app-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                  <path d="M14 36c-2.21 0-3.98 1.79-3.98 4s1.77 4 3.98 4 4-1.79 4-4-1.79-4-4-4zm-12-32v4h4l7.19 15.17-2.7 4.9c-.31.58-.49 1.23-.49 1.93 0 2.21 1.79 4 4 4h24v-4h-23.15c-.28 0-.5-.22-.5-.5 0-.09.02-.17.06-.24l1.79-3.26h14.9c1.5 0 2.81-.83 3.5-2.06l7.15-12.98c.16-.28.25-.61.25-.96 0-1.11-.9-2-2-2h-29.57l-1.9-4h-6.53zm32 32c-2.21 0-3.98 1.79-3.98 4s1.77 4 3.98 4 4-1.79 4-4-1.79-4-4-4z" />
                  <path d="M0 0h48v48h-48z" fill="none" />
                </svg>
              </Link>
              <Input className="app-search" placeholder="Search products" />
              <Button className="app-logout" type="link" href="/#/logout">
                Logout
              </Button>
            </LayoutHeader>
            <LayoutContent className="app-content">
              <Switch>
                <Route path="/logout">
                  <Logout />
                </Route>
                <Route path="/settings/:demoIndex">
                  <DemoSettings />
                </Route>
                <Route path="/play/:demoIndex">
                  <DemoExecution />
                </Route>
                <Route path="/">
                  <DemoList />
                </Route>
              </Switch>
            </LayoutContent>
          </>
        ) : (
          <Login />
        )}
      </Layout>
    </ErrorBoundary>
  );
}

export default App;
